const ContactUsRoutes = {
  createContactUsMainText: "/createContactUsMainText",
  getContactUsMainText: "/getContactUsMainText",
  updateContactUsMainText: "/updateContactUsMainText",
  getLogisticsPartner: "/getLogisticsPartner",
};

export default ContactUsRoutes;
